import axios from "axios";
import { useMemo, useState } from "react";



interface api {
    loading: boolean;
    error: boolean;
    data: any;
}

const getData = async () => {
    try {
        const { data } = await axios.get(
          "https://nftsurfaceboard.up.railway.app/api/aggregations/y00tsGraphData"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useSolanaGraphData() {
    const [api, setAPIData] = useState<api>({
        loading: true,
        error: false,
        data: [] || undefined
    });



    useMemo(async () => {
        const data = await getData();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
